/**
 * Spelling-only US presentation of customer UI strings. Keep the source English
 * catalogue (and legal, brand, editorial, policy and operator copy) unchanged.
 * Word boundaries avoid touching translation keys, interpolation names, URLs
 * and brand names. New copy should be authored for both dialects explicitly.
 */
const UI_SECTIONS = new Set([
  "auth", "booking", "car", "cars", "checkout", "common", "filters",
  "languageModal", "listing", "messages", "nav", "notifications",
  "profile", "search", "settings", "trips",
]);

const SPELLINGS: Record<string, string> = {
  colour: "color", colours: "colors", favourite: "favorite",
  favourites: "favorites", centre: "center", centres: "centers",
  cancelled: "canceled", cancelling: "canceling", travelling: "traveling",
  recognise: "recognize", authorise: "authorize", honour: "honor",
};

function americanize(text: string): string {
  return text.replace(/\b(colour|colours|favourite|favourites|centre|centres|cancelled|cancelling|travelling|recognise|authorise|honour)\b/gi, (word) => {
    const replacement = SPELLINGS[word.toLowerCase()];
    return word[0] === word[0].toUpperCase()
      ? replacement[0].toUpperCase() + replacement.slice(1)
      : replacement;
  });
}

function transform(value: unknown): unknown {
  if (typeof value === "string") return americanize(value);
  if (Array.isArray(value)) return value.map(transform);
  if (value && typeof value === "object") {
    return Object.fromEntries(Object.entries(value).map(([key, child]) => [key, transform(child)]));
  }
  return value;
}

export function usEnglishUiTranslation(source: Record<string, unknown>): Record<string, unknown> {
  return Object.fromEntries(Object.entries(source).map(([key, value]) => [
    key, UI_SECTIONS.has(key) ? transform(value) : value,
  ]));
}